import * as type from './mutation-types'

const setArvore = async ({commit}, obj) => {
  const {data} = await axios.post(`${process.env.API_PATH}/arvore`, obj)
}

const setSelected = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/arvore/${obj.id}`)
  commit(type.SET_SELECTED, data)
}

const setList = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/arvore`)
  commit('SET_LIST', {list: data})
}

const atualizaFolhas = async ({ commit } , obj) => {
  const {data} = await axios.put(`${process.env.API_PATH}/arvore/${obj.arvoreid}/folhas/${obj.parentId}` , obj)
}

export default {
  setArvore,
  setList,
  setSelected,
  atualizaFolhas
}



// WEBPACK FOOTER //
// ./src/features/Arvore/store/actions.js